import template from './footer-bar.html';

export default class FooterBarComponent {
  constructor() {
    this.template = template;
    this.transclude = true;
    this.bindings = {
      classes: '@?',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/footer-bar/footer-bar-component.js